<template>
  <b-card>
    <b-row>
      <b-col md="6">
        <h3>{{ $route.name }}</h3>
        <b-breadcrumb>
          <b-breadcrumb-item
            ><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item
          >
          <b-breadcrumb-item
            ><router-link to="/new-reimbursement/category-reimbursement"
              >Category Reimbursement</router-link
            ></b-breadcrumb-item
          >
          <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
        </b-breadcrumb>
      </b-col>
      
    </b-row>

    <b-row class="mt-2">
      <b-col md="2">
        <label for="" class="labels">Category Name</label>
      </b-col>
      <b-col md="1"></b-col>
      <b-col md="4">
        <p>{{ model.categoryName }}</p>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="2">
        <label for="" class="labels">Category Note</label>
      </b-col>
      <b-col md="1"></b-col>
      <b-col md="4">
        <p>{{ model.categoryNote }}</p>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="2">
        <label for="" class="labels">Account</label>
      </b-col>
      <b-col md="1"></b-col>
      <b-col md="4">
        <p>
          {{
            model.journalAccount.journalAccountCode +
              ' - ' +
              model.journalAccount.journalAccountName
          }}
        </p>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="2">
        <label for="" class="labels">Category Icon</label>
      </b-col>
      <b-col md="1"></b-col>
      <b-col md="4">
        <b-img :src="model.categoryIcon" height="100px"></b-img>
      </b-col>
    </b-row>
     <b-button class="mt-3" :to="'/new-reimbursement/category-reimbursement'" variant="secondary"
        ><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button
      >
      <b-button
        class="mt-3 float-right"
        :to="'/new-reimbursement/category-reimbursement/' + $route.params.uuid + '/edit'"
        variant="warning"
        ><font-awesome-icon icon="pencil-alt"></font-awesome-icon> Edit</b-button
      >
  </b-card>
</template>

<script>
export default {
  data() {
    return {
      model: {
        categoryName: '',
        categoryIcon: '',
        categoryNote: '',
        journalAccount: {},
      },
    };
  },

  mounted() {
    this.getDetail();
  },

  methods: {
    getDetail() {
      this.$http
        .get(window.AppConfig.apiUrl + 'reimbursement-category' + '/' + this.$route.params.uuid)
        .then((response) => {
          this.model.categoryName = response.data.categoryName;
          this.model.categoryIcon = response.data.categoryIcon;
          this.model.categoryNote = response.data.categoryNote;
          if (response.data.journalAccount !== null) {
            this.model.journalAccount = response.data.journalAccount;
          }
        });
    },
  },
};
</script>
